import script from "./AppPreloader.vue?vue&type=script&setup=true&lang=js"
export * from "./AppPreloader.vue?vue&type=script&setup=true&lang=js"

import "./AppPreloader.vue?vue&type=style&index=0&id=45a03d56&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-45a03d56"]])

export default __exports__